<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout px-2 wrap justify-center>
      <v-flex xs12 sm12 md10 pa-2 text-left>
        <span
          style="font-family:opensansregular;font-size:12px;color:#686868;"
          class="text-capitalize"
          v-if="loadContent"
        >{{productData.category.name}}</span>
        <v-icon size="15" color="#686868">mdi-chevron-right</v-icon>
        <span
          style="font-family:opensansregular;font-size:12px;color:#686868;"
          class="text-capitalize"
          v-if="loadContent"
        >{{productData.subcategory.name}}</span>
        <v-icon size="15" color="#686868">mdi-chevron-right</v-icon>
        <span
          style="font-family:opensansregular;font-size:12px;color:#686868;"
          class="text-capitalize"
          v-if="loadContent"
        >{{productData.productname}}</span>
      </v-flex>
    </v-layout>
    <v-layout px-2 wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl10>
        <ProductDetails v-if="loadContent" v-bind:productData="productData" />
      </v-flex>
      <v-flex pt-4 xs12 sm12 md12 lg12 xl10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex pt-4 xs12 sm12 md12 lg12 xl10>
        <ProductDescription v-if="loadContent" v-bind:productData="productData" />
      </v-flex>
      <v-flex pt-4 xs12 sm12 md12 lg12 xl10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl10>
        <SimilarProducts />
      </v-flex>
      <v-flex pt-4 xs12 sm12 md12 lg12 xl10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl10>
        <Review v-if="loadContent" v-bind:productData="productData" />
      </v-flex>
      <v-flex pt-4 xs12 sm12 md12 lg12 xl10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl10>
        <BestSellerProducts />
      </v-flex>
      <v-flex pt-4 xs12 sm12 md12 lg12 xl10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl10>
        <YourBrowsingHistory v-if="getVal" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
import ProductDetails from "./productDetails";
import ProductDescription from "./productDescription";
import Review from "./review";
import SimilarProducts from "./similarProducts";
import BestSellerProducts from "./bestSellerProducts";
import YourBrowsingHistory from "./yourBrowsingHistory";
export default {
  props: ["id", "product"],
  components: {
    ProductDetails,
    ProductDescription,
    Review,
    SimilarProducts,
    BestSellerProducts,
    YourBrowsingHistory,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      productData: {},
      loadContent: false,
      getVal: store.state.isLoggedIn,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // pincode: 685531,
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.productData = response.data.data;
          this.loadContent = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>